<div [hidden]="!message" class="alert alert-{{ type }}" role="alert" #alertNotice>
  <div class="alert-text" [innerHTML]="message"></div>
  <fa-icon [icon]="'times'" (click)="message = null"></fa-icon>
</div>
